// extracted by mini-css-extract-plugin
export default {"pageFornecedorList":"Fornecedor_pageFornecedorList__Plvit","formCadFornecedor":"Fornecedor_formCadFornecedor__icEa0","btnEdit":"Fornecedor_btnEdit__Apqug"};